(() => {
  angular.module('app').component('hostPanelRecruitmentPanelRequestEditorComponent', {
    templateUrl: require('./panelRequestEditor.component.html'),
    controller: PanelRequestEditorController,
    controllerAs: 'vm',
    bindings: {
      panelRequestEditModel: '<',
      onSaved: '&',
      isEdit: '=',
    },
  });

  PanelRequestEditorController.$inject = [
    '$timeout',
    '$scope',
    '$uibModal',
    'abp.services.app.panelRequest',
    'Hms.MultiTenancy.TenantClinicType',
    'Hms.PanelRequests.PanelRequestSource',
    'Hms.PanelRequests.PanelRequestPriority',
    'Tenant',
    'Hms.PanelRequests.PanelRequest',
  ];

  function PanelRequestEditorController(
    $timeout,
    $scope,
    $modal,
    panelRequestSvc,
    enumTenantClinicType,
    enumPanelRequestSource,
    enumPanelRequestPriority,
    constsTenant,
    constsPanelRequest
  ) {
    const vm = this;

    // Constants & Enums
    vm.constsTenant = constsTenant;
    vm.constsPanelRequest = constsPanelRequest;
    vm.enums = {
      tenantClinicType: enumTenantClinicType,
      panelRequestSource: enumPanelRequestSource,
      panelRequestPriority: enumPanelRequestPriority,
    };

    // State
    vm.loading = 0;
    vm.saving = 0;
    vm.isEdit = false;
    vm.showMapSearch = false;
    vm.request = null;
    vm.requestBackup = null;
    vm.isRequestAssignee = false;
    vm.masterCorporates = null;
    vm.filteredMasterCorporates = null;

    // Permissions
    vm.permissions = {
      edit: abp.auth.isGranted('PanelRequests.Host.Edit'),
      override: abp.auth.isGranted('PanelRequests.Host.Override'),
      merge: abp.auth.isGranted('PanelRequests.Host.Merge'),
    };

    // Lifecycle Hook
    vm.$onChanges = function onChanges(changes) {
      if (changes.panelRequestEditModel) {
        loadPanelRequest(changes.panelRequestEditModel.currentValue);
      }
    };

    // Actions
    vm.editRequest = () => toggleEditMode(true, true);
    vm.cancelEdit = () => {
      toggleEditMode(true, false);
      vm.showMapSearch = false;
    };

    vm.updateRequest = function updateRequest() {
      if (!vm.validateForm()) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }

      if (_.isEmpty(vm.request.email)) {
        vm.request.email = null;
      }

      vm.saving += 1;
      panelRequestSvc
        .editPanelRequest(vm.request)
        .success(() => {
          abp.notify.info(App.localize('SuccessfullySaved'));
          toggleEditMode(true, false);
        })
        .finally(() => {
          vm.saving -= 1;
          vm.onSaved();
        });
    };

    vm.mergeRequest = function mergeRequest() {
      $modal
        .open({
          templateUrl: require('../mergePanelRequests/mergePanelRequests.modal.html'),
          controller: 'host.views.panelRecruitment.mergePanelRequestsModal as vm',
          backdrop: 'static',
          resolve: {
            requestNumber: () => vm.request.requestNumber,
          },
        })
        .result.then(vm.onSaved);
    };

    vm.validateForm = function validateForm() {
      const form = $scope.requestInformation;
      App.touchFormErrors(form);
      return form.$valid && !vm.invalidPostcode;
    };

    vm.latLngUpdated = function latLngUpdated() {
      if (!vm.map.isInit) return;
      const latLng = getLatLngForMap();
      vm.map.center = convertLatLng(latLng);
      vm.map.marker.coords = convertLatLng(latLng);
      vm.map.hasLatLng = !!vm.request.latLng;
    };

    vm.filterMasterCorporates = function filterMasterCorporates() {
      vm.filteredMasterCorporates = _.filter(
        vm.masterCorporates,
        (m) =>
          m.accountOwnerCountryCode === vm.request.countryCode || m.accountOwnerCountryCode === null
      );
    };

    // Map Setup
    vm.map = {
      isInit: false,
      hasLatLng: true,
      marker: {
        id: 1,
        coords: {},
        options: { draggable: true },
        events: {
          dragend(marker) {
            vm.request.latLng = {
              lat: marker.getPosition().lat(),
              lng: marker.getPosition().lng(),
            };
          },
        },
      },
      searchbox: {
        options: {
          autocomplete: true,
          componentRestrictions: {
            country: abp.setting.get('Hms.General.DefaultCountryCode'),
          },
        },
        events: {
          // eslint-disable-next-line camelcase
          place_changed(searchBox) {
            const place = searchBox.getPlace();
            vm.request.latLng = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            vm.map.center = convertLatLng(vm.request.latLng);
            vm.latLngUpdated();
          },
        },
      },
      options: App.createMapOptions(),
      init() {
        if (vm.map.isInit) return;

        const latLng = getLatLngForMap();
        vm.map.center = convertLatLng(latLng);
        vm.map.marker.coords = convertLatLng(latLng);
        vm.map.isInit = true;
        vm.map.hasLatLng = !!vm.request.latLng;

        if (!vm.request.latLng) {
          $timeout(() => {
            vm.map.hasLatLng = false;
          }, 250);
        }
      },
    };

    // Internal Helpers
    function loadPanelRequest(data) {
      if (!data) return;

      vm.request = data.request;
      vm.isRequestAssignee = data.request.masterOpsUserId === abp.session.userId;
      vm.masterCorporates = data.masterCorporates;
      vm.filterMasterCorporates();

      if (vm.request.latLng) {
        vm.map.center = convertLatLng(vm.request.latLng);
      }

      vm.latLngUpdated();
      vm.map.init();
    }

    function toggleEditMode(restore, isEdit) {
      if (!isEdit && restore) {
        vm.request = vm.requestBackup;
      } else if (isEdit) {
        vm.requestBackup = angular.copy(vm.request);
      }
      vm.isEdit = isEdit;
    }

    function getLatLngForMap() {
      return vm.request?.latLng || { lat: 3.031647, lng: 101.617452 };
    }

    function convertLatLng(latLng) {
      return {
        latitude: latLng.lat,
        longitude: latLng.lng,
      };
    }
  }
})();
